/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_Name_PlaceholderInputs */

const en_settings_apikeys_key_name_placeholder = /** @type {(inputs: Settings_Apikeys_Key_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Production, Development`)
};

/**
* | output |
* | --- |
* | "e.g. Production, Development" |
*
* @param {Settings_Apikeys_Key_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_name_placeholder = /** @type {((inputs?: Settings_Apikeys_Key_Name_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_Name_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_key_name_placeholder(inputs)
});
export { settings_apikeys_key_name_placeholder as "settings.apikeys.key_name_placeholder" }